import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  class: "prepend"
}
const _hoisted_3 = {
  key: 1,
  class: "append"
}
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dimensions_icon = _resolveComponent("dimensions-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-block-input dimension", { 'editing': _ctx.editingValue }])
  }, [
    (!_ctx.editingValue || _ctx.disableEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon", {}, () => [
            _createVNode(_component_dimensions_icon, { dimension: _ctx.dimension }, null, 8, ["dimension"])
          ], true),
          _renderSlot(_ctx.$slots, "label", { inputState: _ctx.inputState }, () => [
            _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'static': !_ctx.editingValue || _ctx.disableEditing, 'editing': _ctx.editingValue && !_ctx.disableEditing }])
    }, [
      (!_ctx.editingValue || _ctx.disableEditing)
        ? _renderSlot(_ctx.$slots, "static", {
            key: 0,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.prepend)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.prepend), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_ctx.inputState.value), 1),
            (_ctx.append)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.append), 1))
              : _createCommentVNode("", true)
          ], true)
        : _renderSlot(_ctx.$slots, "input", {
            key: 1,
            inputState: _ctx.inputState
          }, () => [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "icon", {}, () => [
                _createVNode(_component_dimensions_icon, { dimension: _ctx.dimension }, null, 8, ["dimension"])
              ], true),
              _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_input, {
                modelValue: _ctx.inputState.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputState.value) = $event)),
                type: "number",
                rules: [value => value >= _ctx.min || ''],
                "no-error-icon": "",
                autocomplete: "off",
                dense: "",
                "hide-hint": true,
                "hide-bottom-space": true,
                "input-style": { fontSize: '1.125rem', color: '#253372', fontWeight: '800', opacity: '80%' }
              }, null, 8, ["modelValue", "rules"])
            ])
          ], true)
    ], 2)
  ], 2))
}